<template>
  <div>
    <div class="row">
      <div class="col-md-7">
        <h4 style="font-weight: bold;color:#3d464c;">
          {{ $t($route.name) }}
          <span v-if="$route.params.id != undefined">№{{ $route.params.id }}</span>
          {{ datas.datetime}}
          <button type="button" v-if="$route.params.id!=undefined && settedrule.change==true" @click="Change()"
          class="btn btn-primary change">{{$t('Ўзгартириш')}}</button>
        </h4>
      </div>
      <div class="col-md-5 end">
        <router-link class="btn btn-danger" :to="{ path: '/kontragentinitial/index' }">
          <button type="button" class="closebutton">
            <b-icon icon="x-lg"></b-icon>
          </button>
        </router-link>
      </div>
    </div>
    <div class="rowform">
       <div class="col-md-1 topheader">
        <span>
          <label for="">Факт №</label>
          <input type="number" class="input100" v-model="datas.number" :disabled="changedisabled">
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label for="">{{$t('Вақт')}}</label>
          <input type="datetime-local" class="input100" v-model="datas.datetime" :disabled="changedisabled">
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label>Склад</label>
            <v-select
              :clearable="false"
              class="form-control-sm required md-input"
              :options="skladlist"
              :disabled="changedisabled"
              v-model="datas.sklad_id"
              :reduce="name => name.id"
              label="name"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  v-bind="attributes"
                  v-on="events"
                  aria-activedescendant="null"
                />
              </template>
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >
                  {{ $t("бўйича маьлумот йўқ") }}
                </template>
                <em style="opacity: 0.5" v-else>Маьлумот йўқ</em>
              </template>
            </v-select>
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label>Сумма</label><br>
          {{ datas.summa | numFormat }}
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label>Доллар Сумма</label><br>
          {{ datas.dollar_summa | numFormat }}
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label for="">{{$t('Курс')}}</label>
          <input type="text" class="input100" v-model="datas.dollar_rate" :disabled="changedisabled">
        </span>
      </div>
    </div>
    <div class="table100percent">
      <md-card>
        <md-card-content>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th class="column0">№</th>
                <th class="column3">Контрагент</th>
                <th class="column3">Тўлов тури</th>
                <th class="column3">Тури</th>
                <th class="column2">Сумма</th>
                <th class="column3">Комментарий</th>
                <th class="column0"></th>
              </tr>
            </thead>
            <tbody style="overflow: hidden;">
              <div style="overflow-y: scroll;height: 62vh!important;"
              >
                <tr
                  v-for="(item, index) in datas.kontragent_initial_table"
                  :key="index"
                >
                  <td class="column0">{{ index + 1 }}</td>
                  <td class="column3">
                    <v-select
                      :clearable="false"
                      class="form-control-sm required"
                      :options="kontragentlist"
                      v-model="item.kontragent_id"
                      :reduce="name => name.id"
                      :disabled="changedisabled"
                      label="name"
                      required="true"
                    >
                    <template #list-footer>
                      <li style="text-align: center;font-weight:bold;">
                        f4 {{ $t("умумий рўйхат") }}
                      </li>
                    </template>
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        ref="focused"
                        v-bind="attributes"
                        v-on="events"
                      />
                      <button
                        type="button"
                        class="modallist"
                        @click="$store.state.select_kontragent = index;"
                        v-b-modal.modal-kontragentlist
                      >
                        <b-icon icon="three-dots"></b-icon>
                      </button>
                    </template>
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        <em
                          ><b>{{ search }}</b></em
                        >
                        {{ $t("бўйича маьлумот йўқ") }}
                        <button
                          type="button"
                          class="pluss"
                          @click="$store.state.select_kontragent = index;kontragent.name=search"
                          v-b-modal.modal-kontragent
                        >
                          +
                        </button>
                        <b>insert</b>
                      </template>
                      <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
                    </template>
                    </v-select>
                  </td>
                  <td class="column3">
                    <v-select
                      :clearable="false"
                      class="form-control-sm required"
                      :options="paytypelist"
                      v-model="item.pay_type_id"
                      :reduce="name => name.id"
                      :disabled="changedisabled"
                      label="name"
                      required="true"
                    >
                    </v-select>
                  </td>
                  <td class="column3">
                    <v-select
                      :clearable="false"
                      class="form-control-sm required"
                      :options="typelist"
                      v-model="item.type"
                      :reduce="name => name.id"
                      :disabled="changedisabled"
                      label="name"
                      required="true"
                    ></v-select>
                  </td>
                  <td class="column2">
                    <vue-numeric
                      separator="space"
                      v-model="item.summa"
                      @change="Summa()"
                      style="text-align: right;"
                      class="table-input"
                      :disabled="changedisabled"
                      v-bind:precision="2"
                    ></vue-numeric>
                  </td>
                  <td class="column3">
                    <input
                      v-model="item.comment"
                      style="width:100%"
                      class="table-input"
                      :disabled="changedisabled"
                    />
                  </td>
                  <td class="column0">
                    <a
                      href="javascript:void(0)"
                      class="circul trash"
                      @click="Trashitem(index)"
                      v-if="changedisabled==false"
                    >
                      <b-icon icon="trash"></b-icon>
                    </a>
                  </td>
                </tr>
              </div>
            </tbody>
          </table>
        </md-card-content>
      </md-card>
    </div>
    <div class="row">
      <div class="col-md-12 end formbottom" v-if="changedisabled==false">
        <button class="btn btn-success addrow" type="button" @click="Addtable()" :disabled="changedisabled">
          <b-icon icon="plus-lg"></b-icon><sup>F1</sup>
        </button>
        <button class="btn btn-success" type="button" @click="Savedokument('save')">
          {{ $t("Сақлаш") }}
        </button>
        <button type="button" class="mybtn btn saved" @click="Savedokument()">
          {{ $t("Сақлаш ва беркитиш") }} <sup>ctrl+enter</sup>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { print } from "../../components/mixins/print.js";
export default {
  name: "KontragentIntialForm",
  mixins: [print],
  data() {
    return {
      typelist: [
        { id: false, name: "Қарзи" },
        { id: true, name: "Хаққи" }
      ],
      sklad: "",
      paytype: "",
      kontragent: "",
      skladlist: [],
      paytypelist: [],
      kontragentlist: []
    };
  },
  props: ["datas", "errors"],
  created() {
    let self = this;
    self.$root.$refs.initialkontragent = self;
    self.$root.$on("skladone", function(getdata) {
      self.sklad = getdata;
    });
    self.$root.$on("skladall", function(getdata) {
      self.skladlist = getdata;
    });
    self.$root.$on("paytypeone", function(getdata) {
      self.paytype = getdata;
    });
    self.$root.$on("paytypeall", function(getdata) {
      self.paytypelist = getdata;
    });
    self.$root.$on("kontragentone", function(getdata) {
      self.kontragent = getdata;
    });
    self.$root.$on("kontragentall", function(getdata) {
      self.kontragentlist = getdata;
    });
  },
  mounted: function() {
    let self = this;
    setTimeout(() => {
      self.Focus();
      this.SetRule('/kontragentinitial/index');
      self.datas.datetime=self.SetDatetime(self.datas.datetime);
    }, 100);
  },
  methods: {
    Createkontragent(index,search){
      this.$store.state.select_kontragent = index;
      this.kontragent.name = search;
      this.$bvModal.show('modal-kontragent');
    },
    Summa() {
      this.datas.summa = 0;
      this.datas.dollar_summa = 0;
      let self = this;
      this.datas.kontragent_initial_table.forEach(function(key, value) {
        if(key.pay_type_id==3){
          if(key.type==true){
            self.datas.dollar_summa += parseFloat(key.summa);  
          }else{
            self.datas.dollar_summa -= parseFloat(key.summa);  
          }
        }else{
          if(key.type==true){
            self.datas.summa += parseFloat(key.summa);  
          }else{
            self.datas.summa -= parseFloat(key.summa);  
          }
        }
      });
    },
    Focus() {
      $(".vs__search")
        .eq(1)
        .focus();
    },
    Selectbase(index) {
      this.$store.state.selected_index = index;
    },
    Selectpaytype(index) {
      this.$root.$emit("tableselect", index);
    },
    Addtable() {
        this.datas.kontragent_initial_table.push({
          kontragent_id: 0,
          summa: 0,
          pay_type_id: 0,
          type: false,
          comment: "",
        });
      this.Tablefocus();
    },
    Addtableindex(index) {
      if (this.datas.kontragent_initial_table.length == index + 1) {
        this.datas.kontragent_initial_table.push({
          base_id: 0,
          summa: 0,
          pay_type_id: 0,
          type: false,
          comment: "",
        });
      }
    },
    Trashitem(index) {
      const answer = window.confirm(this.$t("Malumotlar ochirilsinmi?"));
      if (answer) {
        this.datas.kontragent_initial_table.splice(index, 1);
      }
    },
    Savedokument(type='default') {
      let self = this;
            if(self.rule.change==true){
      if (this.$route.path == "/kontragentinitial/create") {
        var methods = "post";
        var action = "api/v1/kontragent-initial";
      } else {
        var methods = "patch";
        var action = "api/v1/kontragent-initial/id/" + self.$route.params.id;
      }
       self.datas.datetime = new Date(self.datas.datetime)
        .valueOf()
        .toString()
        .slice(0, 10);
      axios({
        method: methods,
        url: action,
        data: self.datas
      }).then(function(response) {
        self.$store.state.saved = null;
        if(type=='save'){
          self.$router.push({ path: "/kontragentinitial/update/" + response.data.id });
        }else{
        self.$router.push({ name: "Kontragentinitial" });
        }
      });
       } else{
          self.$store.state.errors=self.$t('Sizdan bunday xuquq mavjud emas');
    }
    }
  }
};
</script>

<style lang="scss" scoped>
.md-dialog .md-dialog-container {
  max-width: 768px;
}
</style>
